<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-empresas'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-empresas"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="fields"
          primary-key="id"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>
          <template #cell(empresa_info)="data">
            <div class="d-flex flex-column gap-1">
              <div class="d-flex justify-content-between">
                <strong class="mr-1">RUC:</strong>
                <span>{{ data.item.ruc }}</span>
              </div>
              <div class="d-flex justify-content-between">
                <strong class="mr-1">Razón Social:</strong>
                <span>{{ data.item.razon_social }}</span>
              </div>
              <div class="d-flex justify-content-between">
                <strong class="mr-1">Nombre Comercial:</strong>
                <span>{{ data.item.nombre_comercial || "-" }}</span>
              </div>
            </div>
          </template>

          <!-- DIRECCIÓN -->
          <template #cell(direccion)="data">
            <span>{{ data.value ? data.value : "-" }}</span>
          </template>

          <!-- TELÉFONO -->
          <template #cell(telefono)="data">
            <span>{{ data.value ? data.value : "-" }}</span>
          </template>

          <!-- CORREO -->
          <template #cell(correo)="data">
            <span>{{ data.value ? data.value : "-" }}</span>
          </template>

          <!-- REPRESENTANTE LEGAL -->
          <template #cell(representante_legal)="data">
            <span>{{ data.value ? data.value : "-" }}</span>
          </template>

          <!-- ESTADO -->
          <template #cell(estado)="data">
            <b-badge
              :variant="data.value == 1 ? 'light-success' : 'light-danger'"
            >
              {{ data.value == 1 ? "ACTIVO" : "INACTIVO" }}
            </b-badge>
          </template>

          <!-- LOGO (opcional) -->
          <template #cell(logo)="data">
            <b-img
              :src="data.value"
              fluid
              height="50"
              width="50"
              alt="Logo"
              v-if="data.value"
            />
          </template>

          <!-- ACCIONES -->
          <template #cell(id)="data">
            <feather-icon
              icon="EditIcon"
              size="17"
              class="cursor-pointer text-warning mr-1"
              @click="toggleModal(data.item.empresa_id)"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>

    <EmpresasModal
      v-if="showModal"
      :empresaId="empresaId"
      @hidden="toggleModal"
      @refresh="handleRefresh"
    />
  </div>
</template>

<script>
import EmpresasModal from "@/views/settings/views/empresas/components/modal/EmpresasModal.vue";
import EmpresaService from "@/views/settings/views/empresas/service/empresa.service.js";
import Fields from "@/views/settings/views/empresas/data/fields.data.js";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

export default {
  components: {
    FilterSlot,
    EmpresasModal,
  },
  data() {
    return {
      fields: Fields,
      showModal: false,
      empresaId: null,
      filters: [],
      isBusy: false,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "SEARCH...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
    };
  },
  methods: {
    toggleModal(empresaId = null) {
      this.showModal = !this.showModal;

      if (empresaId) {
        this.empresaId = empresaId;
      } else {
        this.empresaId = null;
      }
    },
    handleRefresh() {
      this.toggleModal();
      this.$refs["ref-table-empresas"].refresh();
    },
    async myProvider(ctx) {
      try {
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search_txt: this.filterPrincipal.model,
        };
        const { data } = await EmpresaService.index(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
</style>